import { useState, useEffect } from 'react';

import { useSelectedFactsDb } from '../../hooks/useSelectedFactsDb';
import useFactsData from '@/api/queries/useGetFacts';

export const useIncludedFacts = (caseId: string, isOpen: boolean) => {
  const [selectedFactIds, setSelectedFactIds] = useState<string[]>([]);
  const { getAllSelectedIds } = useSelectedFactsDb();

  // Get selected fact IDs from IndexedDB when modal opens
  useEffect(() => {
    if (isOpen && caseId) {
      getAllSelectedIds(caseId).then((ids) => {
        setSelectedFactIds(ids);
      });
    }
  }, [isOpen, caseId, getAllSelectedIds]);

  const { data: factsResponse } = useFactsData({
    docId: null,
    caseId,
    searchQuery: '',
    page: 1,
    pageSize: 1000,
    filters: {
      factIds: selectedFactIds.length > 0 ? selectedFactIds : undefined,
    },
  });

  const facts = factsResponse?.facts || [];
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  // Reset current index when modal opens
  useEffect(() => {
    if (isOpen) {
      setCurrentFactIndex(0);
    }
  }, [isOpen]);

  // Ensure currentFactIndex is within bounds
  useEffect(() => {
    if (facts.length > 0 && currentFactIndex >= facts.length) {
      setCurrentFactIndex(0);
    }
  }, [facts.length, currentFactIndex]);

  const handlePrevFact = () => {
    setCurrentFactIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextFact = () => {
    setCurrentFactIndex((prev) => Math.min(facts.length - 1, prev + 1));
  };

  return {
    facts,
    currentFactIndex,
    currentFact: facts[currentFactIndex],
    handlePrevFact,
    handleNextFact,
  };
};
